'use client'

import { useLanguage } from '@/app/LanguageContext'

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage()

  return (
    <div className="flex items-center gap-1 px-2 py-1 rounded-md border border-[#D8E2E7] bg-white">
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 text-sm font-medium rounded transition-colors duration-140 ${
          language === 'en'
            ? 'bg-[#00534C] text-white'
            : 'text-[#5B6B7A] hover:text-[#00534C]'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <div className="text-[#D8E2E7]">|</div>
      <button
        onClick={() => setLanguage('ar')}
        className={`px-3 py-1 text-sm font-medium rounded transition-colors duration-140 ${
          language === 'ar'
            ? 'bg-[#00534C] text-white'
            : 'text-[#5B6B7A] hover:text-[#00534C]'
        }`}
        aria-label="Switch to Arabic"
      >
        العربية
      </button>
    </div>
  )
}
